<template>
    <div class="menu-editor-form form-horizontal">         
        <div class="menu-editor-form form-horizontal">     
            <div class="form-group"  :class="{'has-error': errors['is_menu']}">
                <label for class="col-sm-2 control-label">¿Es menú o ítem?</label>
                <div class="col-sm-10">
                    <el-select :disabled="this.menu.id != 0" v-model="is_menu_value2" placeholder="Seleccione Tipo"   id="is_menu">
                        <el-option
                            v-for="item in is_menu_option"
                            :key="item.is_menu_value"
                            :label="item.is_menu_label"
                            :value="item.is_menu_value">
                        </el-option>
                    </el-select>
                </div>
            </div>
        </div>
        <div v-if="is_menu_value2 != null">
            <form class="menu-editor-form form-horizontal"  @submit.prevent="submit()" >
                <div class="form-group"  :class="{'has- ': errors['name']}">
                    <label v-if="this.is_menu == true || is_menu_value2 == true" for class="col-sm-2 control-label">Nombre Menú</label>
                    <label v-if="this.is_menu == false || is_menu_value2 == false" for class="col-sm-2 control-label">Nombre Ítem</label>
                    <div class="col-sm-10">
                        <input type="text" name="name" id="name" class="form-control"  v-model="data.menu.name" required>
                        <div class="help-block" v-for="e in errors['name']">{{e}}</div>
                    </div>
                </div>         
                <div v-if="this.is_menu == true || is_menu_value2 == true" class="form-group"  :class="{'has-error': errors['typebutton']}">
                    <label for class="col-sm-2 control-label">Forma de presentación</label>
                    <div class="col-sm-10">
                        <el-select  v-model="show_type_button_id" placeholder="Seleccione Logo" id="logo" >
                            <el-option
                                v-for="item in showtypebutton"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                        <div class="help-block" v-if="errors['typebutton']">{{errors['typebutton']}}</div>
                    </div>
                </div>
                <div v-if="this.is_menu == false || is_menu_value2 == false || this.show_type_button_name == true " class="form-group" :class="{'has-error': errors['item_icon_route']}">
                    <label for="item_icon_route" class="col-sm-2 control-label">Ícono </label>
                    <div class="col-sm-10">
                        <!--<input type="text" class="form-control" id="tooltip" v-model="data.icon">-->
                        <icon-menu-select id="item_icon_route" v-model="data.item_icon_route" v-on:input="iconChange"></icon-menu-select>
                        <div class="help-block" v-if="errors['item_icon_route']">{{errors['item_icon_route']}}</div>
                    </div>
                </div>   
                <div v-if="show_type_button_id != 3" class="form-group" :class="{'has-error': errors['textButton']}">
                    <label for class="col-sm-2 control-label">Texto Boton</label>
                    <div class="col-sm-10">
                        <input type="text" name="textButton" id="textButton" class="form-control"  v-model="data.menu.text_button" required>
                        <div class="help-block" v-for="e in errors['textButton']">{{e}}</div>
                    </div>
                </div>
                <div v-if="this.is_menu == false || is_menu_value2 == false" class="form-group">
                    <label for class="col-sm-2 control-label">Tooltip</label>
                    <div class="col-sm-10">
                        <input  type="text" name="tooltip"   v-model="tooltip"   class="form-control"    id="tooltip"  />
                    </div>
                </div>
                <div v-if="this.is_menu == false || is_menu_value2 == false" class="form-group">
                    <label for class="col-sm-2 control-label">Url</label>
                    <div class="col-sm-10">
                        <input type="text" name="url" v-model="url" class="form-control" id="url" placeholder="http://www...." />
                    </div>
                </div>
                <div v-if="this.is_menu == false || is_menu_value2 == false" class="form-group">
                    <label for class="col-sm-2 control-label">Abrir en otra ventana</label>
                    <div class="col-sm-10">
                        <el-switch v-model="on_new_window" on-text="SI" off-text="NO"></el-switch>
                    </div>
                </div>               
                <div v-if="this.is_menu == false || is_menu_value2 == false" class="form-group">
                    <label for class="col-sm-2 control-label">Descripción</label>
                    <div class="col-sm-10">
                        <input type="text" name="description" v-model="description"   class="form-control"  id="description">
                    </div>
                </div>       
                <div v-if="this.is_menu == true || is_menu_value2 == true" class="form-group">
                    <label for class="col-sm-2 control-label">Agregar Nuevo item</label>
                    <div class="col-sm-10">
                    <a href="#" @click.prevent="addItem">
                        <i class="material-icons">add_circle</i>
                    </a>
                    <br />
                    </div>
                </div>
                <div v-if="this.is_menu == true || is_menu_value2 == true"  class="form-group" :class="{'has-error': errors['tree']}">
                    <label for class="col-sm-2 control-label">Organización del Menú</label>
                    <div class="col-sm-10">
                        <div class="border-mb">
                            <vue-tree-list
                            @click="onClick"
                            @drop="onDrop" 
                            :model="data.items"
                            v-bind:default-expanded="true"
                            >
                            <span class="icon" slot="treeNodeIcon"></span>
                            <span class="icon" slot="delNode"></span>
                            </vue-tree-list>
                        </div>
                        <h6>(*)Para editar, clickear en el item deseado.</h6>
                        <div class="help-block" v-if="errors['tree']">{{errors['tree']}}</div>
                    <!--  <div class="help-block" v-for="e in errors['activos']">{{e}}</div> -->
                    </div>
                </div>
                <template v-if="edit">
                    <div class="attr-group">
                        <div class="col-sm-offset-2 col-sm-10 attr-item">
                            <div class="form-group">
                                <label for class="col-sm-offset-3 control-label">Propiedades del item</label>

                            </div>
                            <div class="form-group">
                                <label for class="col-sm-2 control-label">Texto</label>
                                <div class="col-sm-10">
                                    <input type="text" class="form-control" id="name" v-model="name" required />
                                </div>
                            </div>
                            <div class="form-group">
                                <label for class="col-sm-2 control-label">Tootip</label>
                                <div class="col-sm-10">
                                    <input  type="text" name="tooltip"   v-model="tooltip"   class="form-control"    id="tooltip"  />
                                </div>
                            </div>
                            <div v-if="!children" class="form-group">
                                <label for class="col-sm-2 control-label">Url</label>
                                <div class="col-sm-10">
                                    <input type="text" name="url" v-model="url" class="form-control" id="url" placeholder="http://www...." />
                                </div>
                            </div>
                            <div v-if="!children"  class="form-group">
                                <label for class="col-sm-2 control-label">Abrir en otra ventana</label>
                                <div class="col-sm-10">
                                    <el-switch v-model="on_new_window" on-text="SI" off-text="NO"></el-switch>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for class="col-sm-2 control-label">Uso de Material Icons?</label>
                                <div class="col-sm-10">
                                    <el-switch v-model="use_icon" on-text="SI" off-text="NO"></el-switch>
                                </div>
                            </div>
                            <!-- <div v-if="use_icon"  class="form-group">
                                <label for class="col-sm-2 control-label">Material Icons?</label>
                                <div class="col-sm-10">
                                    <el-switch v-model="use_material_icons" on-text="SI" off-text="NO"></el-switch>
                                </div>
                            </div> -->
                            <div  v-if="use_icon" class="form-group">
                                <label for class="col-sm-2 control-label">Icono</label>
                                <div class="col-sm-10">
                                    <input type="text" name="icon" v-model="icon" class="form-control" id="icon" />
                                </div>
                            </div>
                            <div class="form-group">
                                <label for class="col-sm-2 control-label">Descripcion</label>
                                <div class="col-sm-10">
                                    <input type="text" name="description" v-model="description"   class="form-control"  id="description">
                                </div>
                            </div>
                            <div class="form-group">
                                <label for class="col-sm-2 control-label">Activo</label>
                                <div class="col-sm-10">
                                    <el-switch v-model="active" on-text="SI" off-text="NO"></el-switch>
                                </div>
                            </div>
                            <div class="col-sm-offset-2 col-sm-10 control-label">
                                <a v-if="id != 0 && !close_button ? true:false " role="button" @click.prevent="onDelNode"    >
                                    <i class="material-icons">delete</i>
                                </a>
                                <a @click.prevent="updateNode" role="button">
                                    <i class="material-icons">save</i>
                                </a>
                            </div>
                        </div>
                    </div>
                </template>
                <div class="form-group" >
                    <label for class="col-sm-2 control-label">Previsualización</label>
                    <div class="col-sm-10 ">
                        <div class="menu-cha" >
                            <div class="cont-menu">
                                <div class="dropdown">
                                    <button type="button"  data-toggle="dropdown" class="dropdown-toggle "  :class="menu.is_login ?'btn btn-primary btn-ingresar':'btn-menu '"  >
                                        <div v-if="!menu.is_login  && show_type_button_id > 3 && data.menu.item_icon_route !=''">
                                            <a href="" :class="'btn-'+data.menu.item_icon_route"><span :class="data.menu.item_icon_route"></span>{{data.menu.text_button}}</a>                                            
                                        </div>
                                        <div v-else>
                                            {{ show_type_button_id!= 3 ? data.menu.text_button: ''}}
                                        </div>
                                        <div v-if="!menu.is_login  && show_type_button_id == 1 || show_type_button_id == 3" class="menu-icon" style="color:black">
                                            <span></span> <span></span> <span></span>   
                                        </div>                                
                                    </button>
                                    <ul v-if="is_menu == true" class="dropdown-menu " :class="menu.is_login?'menu-usuario':'menu-contacto'"  > 
                                        <li class="cerrar-menu">
                                            <a href="#" class="btn-cerrar">Cerrar <span class="close">×</span></a>
                                        </li>
                                        <li class="barra"></li>

                                        <li  v-for="item in data.items.children" v-if="item.active">
                                            <a  v-if="isEmpty(item.children)" href="" >
                                                <img v-if="item.use_icon && !item.use_material_icons" :src="item.icon" :alt="item.tooltip" />
                                                <i v-if="item.use_icon && item.use_material_icons" class="material-icons">{{item.icon}}</i>
                                                {{item.name}}
                                            </a>
                                            <a v-else :href="'#SubMenu' + item.id" class="list-group-item" data-toggle="collapse">
                                                {{item.name}}<span class="caret"></span>
                                            </a>                                            
                                            <div v-if="!isEmpty(item.children)" class="collapse in list-group-submenu" :id="'SubMenu' + item.id ">
                                                <a v-for="subitem in item.children" v-if="subitem.active" href="#" class="list-group-item">
                                                    {{subitem.name}} 
                                                </a>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="" class="col-sm-2 control-label">Activo</label>
                    <div class="col-sm-10">
                        <el-switch v-model="data.menu.active" on-text="SI" off-text="NO" >
                        </el-switch>
                    </div>
                </div>
                <div class="form-group">
                    <div v-if="this.errors.length > 0" class="col-sm-offset-2 col-sm-10 help-block" >{{ this.errors }}</div>
                </div>
                <div class="form-group">
                    <div class="col-sm-offset-2 col-sm-10">
                    <a class="btn btn-default" href="backend/mantenedor-navbar">Cancelar</a>
                    <button type="submit" class="btn btn-primary">Guardar</button>
                    </div>
                </div>
            </form>   
        </div>     
    </div>    

</template>
<style lang="scss" scoped>
.border-mb {
  border: 1px dotted #20a0ff;
  margin-bottom: 10px;
}
.row {
  margin-bottom: 5px;
}
.attr-group {
  height: 275px;
}
.attr-item {
  background: #f7f7f7;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-bottom: 15px;
}
.form-control {
  margin-top: 5px;
  margin-bottom: 5px;
}
.menu-cha .cont-menu {
    float: left!important;
}
.menu-contacto {
    right: -188px!important;
}
.menu-usuario{
    right: -217px!important;
}
.menu-cha .dropdown-menu .menu-usuario {
    right: -217px!important;
}
 
.menu-icon span{
    background-color: #000!important;
}
</style>
<script>
import ElementUI from "element-ui";
import ElSwitch from "element-ui/lib/switch";
import ElSelect from 'element-ui/lib/select';
import ElOption from 'element-ui/lib/option';
import Vue from "vue";
import { VueTreeList, Tree, TreeNode } from "vue-tree-list";
import locale from "element-ui/lib/locale/lang/es";
import { Message } from "element-ui";
import IconMenuSelect from './IconMenuSelect.vue';


Vue.use(ElementUI, { locale });


export default {
  components: {
    VueTreeList,
    IconMenuSelect 
  },
  data() {
    const menu = _.cloneDeep(this.menu);
    menu.children = _.values(menu.items);
    
    const tree = new Tree(menu.items);
    this.desactiveButtonTree(tree);

    const data = {
        menu: menu,
        items:tree
    }

    return {
        data : data,
        id: 0,
        name: "",
        tooltip: "",
        url: "",
        on_new_window:true,
        use_icon: true,
        use_material_icons: true,
        icon: "",
        description: "",
        show_type_button_id:menu.show_type_button_id,
        is_menu: menu.is_menu,
        item_icon_route: menu.item_icon_route,
        existLogin: false,
        close_button: false,
        active: true,
        children:false,
        edit: false,
        pid:0,
        is_menu_option: [{
            is_menu_value: '1',
            is_menu_label: 'Menú'
        }, {
            is_menu_value: '0',
            is_menu_label: 'Ítem'
        }],
        is_menu_value2: menu.is_menu === 1  ? 'Menú' : menu.is_menu === 0 ? 'Ítem' : null,
        is_menu_label2: menu.is_menu === 1  ? 'Menú' : menu.is_menu === 0 ? 'Ítem' : null,
        show_type_button_name: menu.show_type_button_name == 'Ícono y texto' ? true : false,
        errors: {}      
    };
  },
  watch:{
        show_type_button_id:function(showId){
            this.data.menu.show_type_button_id = showId;
            var button_name = _.find(this.showtypebutton, { 'id': showId });
            this.show_type_button_name = (button_name.name == 'Ícono y texto') ? true : false;
        },
        is_menu_value2:function(isMenu){
            this.data.menu.is_menu = isMenu;
            if(isMenu == "0"){
                var button_name2 = _.find(this.showtypebutton, { 'name': 'Ícono y texto' });
                this.show_type_button_id = button_name2.id;
            }
        },
        show_type_button_name:function(btnName){
            this.data.menu.show_type_button_name = btnName;
        }
        
  },
  props: ["user","menu","showtypebutton"],
  created: function(){
    if (this.data.menu.is_menu == 0){
        if (this.data.menu.id != 0){
            this.data.item_icon_route = this.data.menu.item_icon_route;
            this.tooltip = this.data.items.children[0].tooltip;
            this.url = this.data.items.children[0].url;
            this.on_new_window = this.data.items.children[0].on_new_window;
            this.description = this.data.items.children[0].description;
            this.id = this.data.items.children[0].id;
        } 
    } else {
        if (this.data.menu.id != 0){
            this.data.item_icon_route = this.data.menu.item_icon_route;
        }
            
    }
     

  },
  methods: {
    iconChange:function(selected){
        this.data.menu.item_icon_route = selected;
    },
    desactiveButtonTree:function(tree){
        if(tree.children)
            tree.children.forEach(t => {
                t.addTreeNodeDisabled = true;
                t.addLeafNodeDisabled = true;
                t.delNodeDisabled =true;
                t.editNodeDisabled =true;
                this.desactiveButtonTree(t);
            });
        
    },
    isEmpty:function(obj){

        if(obj === null)
            return true;
        else
            return false;
    },
    onDel: function(node) {
      this.edit = false;
      node.remove();
    },
    onDelNode: function() {
      var self = this;
      var ok = false;

      this.data.items.children.map(function(item) {
        if (item.id == self.id) {
            item.remove();
            ok=true;
        }
      });

      if(!ok){
        this.data.items.children.forEach(function(item){
            if(item.children)
                item.children.map(function(subitem){
                    if(subitem.id == self.id){
                        subitem.remove();
                    }
                });
        } );
      }


      this.edit = false;
    },
    onDrop: function(data){
        
        if(data.node.pid > 0 ){
            this.data.items.children.forEach(function(item){
                if(item.children)
                    item.children.map(function(subitem){
                        if(subitem.id == data.node.id){
                            subitem.parent_id = data.node.pid;
                        }
                    });
            });
        }
    },
    addItem: function() {
      // this.edit = true;
      this.id = 0;
      this.name = "";
      this.url = "";
      this.icon = "";
      this.tooltip = "";
      this.description = "";
      this.active = true;
      this.errors = {};
      
      this.edit = this.edit == false ? true : false;
      // console.log(this);
    },
    updateNode: function() {
        var self = this;
 
        self.use_material_icons =self.use_icon;

        
        if (this.id == 0) {
            var node = new TreeNode({
                name: self.name,
                tooltip: self.tooltip,
                use_icon: self.use_icon,
                url: self.url,
                on_new_window: self.on_new_window,
                icon: self.icon,
                use_material_icons: self.use_material_icons,
                description: self.description,
                active: self.active,
                menu_id:self.menu.id,
                close_button:false,
                parent_id:0,
                isLeaf: false,
                addTreeNodeDisabled: true,
                addLeafNodeDisabled: true,
                editNodeDisabled: true,
                delNodeDisabled: true,
                pid: 0
            });

            if (!this.data.items.children) 
                this.data.items.children = [];

            this.data.items.addChildren(node);
        }
        else{
            var subitem = true;
            this.data.items.children.map(function(item) {
                if (item.id == self.id) {
                    item.name = self.name;
                    item.tooltip = self.tooltip;
                    item.login = self.login;
                    item.use_icon = self.use_icon;
                    item.url = self.url;
                    item.icon = self.icon;
                    item.use_material_icons = self.use_material_icons;
                    item.description = self.description;
                    item.active = self.active;
                    item.on_new_window = self.on_new_window;
                    subitem = false;
                }
            });

            if(subitem){
                this.data.items.children.forEach(function(item){
                    if(item.children)
                        item.children.map(function(subitem){
                            if(subitem.id == self.id){
                                subitem.name = self.name;
                                subitem.tooltip = self.tooltip;
                                subitem.login = self.login;
                                subitem.use_icon = self.use_icon;
                                subitem.url = self.url;
                                subitem.icon = self.icon;
                                subitem.use_material_icons = self.use_material_icons;
                                subitem.description = self.description;
                                subitem.active = self.active;
                                subitem = false;
                            }
                        });
                });
            }
        }
      
        this.edit = false;
     
    },
    validateItem: function() {

      this.errors = {};
      var errores = {};
      var texto = this.title === "" || this.title === null;
      var url = this.url === "" || this.url === null;
      var icon = (this.use_icon && this.icon === "") || this.icon === null;

      if (texto) errores["texto"] = ["De ingresar un texto al nuevo item"];
      if (url) errores["url"] = ["De ingresar la menos un # como url"];
      if (icon) errores["icon"] = ["Debe ingresar el nombre del icono"];
      
      if (errores.length > 0) {
        this.errors = errores;
        return false;
      } else return true;
    },
    onClick: function(model) {
        if (model.id != this.id) {
            this.edit = true;
            this.id = model.id;
            this.name = model.name;
            this.tooltip = model.tooltip;
            this.url = model.url;
            this.on_new_window = model.on_new_window;
            this.use_icon = model.use_icon;
            this.icon = model.icon;
            this.use_material_icons = model.use_material_icons;
            this.description = model.description;
            this.active = model.active;
            this.close_button = model.close_button;
            this.pid = model.pid;

            if(model.children)
                this.children = true;
            else
                this.children = false;

        } else {
            this.edit = this.edit == false ? true : false;
        }
    },
   
    validateUrl:function(tree){
        var flag = true;

        if(tree.children){
            tree.children.forEach(t => {
                flag = this.validateUrl(t);
            });
        }else{
            if(tree.url){
                if(tree.url.length == 0)
                    flag =  false;
            }
            else{
                flag = false;
            }
        }

        return flag;
    },
    submit:function(){
        var self = this;
        this.errors = {};
        var errores = ''
        var url =- true;
        var type_button_id =_.find(this.showtypebutton, { 'name': 'Ícono y texto' }).id;

        //this.updateNode()

        if (this.data.menu.is_menu == '0'){
            this.updateNode();
            this.data.menu.show_type_button_id =_.find(this.showtypebutton, { 'name': 'Ícono y texto' }).id;
            this.data.menu.item_icon_route = this.data.item_icon_route;
            this.data.items.children[0].name = this.data.menu.text_button;
        } else {
            
            if (this.show_type_button_id == type_button_id) {
                this.data.menu.item_icon_route = this.data.item_icon_route; 
            } else {
                this.data.menu.item_icon_route = '';
            }
        }

        if(this.data.menu.name.length == 0)
            this.errors['name'] = "Debe indicar un nombre descriptivo al menú";

        if(this.data.menu.show_type_button_id){
            if(this.data.menu.show_type_button_id!= 3){
                if(this.data.menu.text_button.length == 0)
                    this.errors['textButton'] = 'Debe ingresar un texto para el botón del menú';     
            }

        }else{
            this.errors['typebutton'] = 'Debe indicar la forma de presentación';     
        }

        if (this.data.menu.show_type_button_id == type_button_id){
            if (!this.data.menu.item_icon_route){
                this.errors['item_icon_route'] = 'Debe indicar un ícono a utilizar'
            }
        }


        if(this.data.items.children){
            if(!this.validateUrl(this.data.items)) 
                this.errors['tree'] =   'Tiene items sin url ingresada';
        }else{
             this.errors['tree'] =   'Tiene que ingresar al menos un item';
        }
    
        if(_.values(this.errors).length ==  0){
            const getCircularReplacer = () => {
                const seen = new WeakSet();
                return (key, value) => {
                    if (typeof value === "object" && value !== null) {
                    if (seen.has(value)) {
                        return;
                    }
                    seen.add(value);
                    }
                    return value;
                };
            };

            this.data.items = JSON.stringify(this.data.items, getCircularReplacer())

            axios({
                url: 'backend/mantenedor-navbar/menu',
                method: "PUT" ,
                data:this.data
            })
            .then(response => {
                window.location.replace(response.data.redirect);
            })
            .catch(error => {
                this.errors = error.response.data.errors;
            });
        }
    }
  }
};
</script>
